<template>
  <v-app>
  </v-app>
</template>

<style>
html {
    height: 100%;
}
body {
    height: 100%;
}
#app {
    height: 100%;
}
</style>

<script>

import App from '@/models/instance/App'
import axios from 'axios';
import config from '@/../config.js'
import AppointmentSelection from '@/models/instance/AppointmentSelection.js'
import Member from '@/models/instance/Member'

export default {
  data () {
    return {

    }
  },
  mounted : function () {
    AppointmentSelection.reset();
    var que = this.$store.commit('addLoading')
    axios
    .post(config.api.url.public.appointment.get_stationmap,{ app_id: App.getAppId()})
    .then(response => {
        AppointmentSelection.setAddfriendUrl(response.data.addfriend_url)
        if(response.data.stationmap_type=="bypass"){
            AppointmentSelection.setStationCode(response.data.stationmap.list[0].station_code);
            axios
            .post(config.api.url.public.station.get_stationshortdetail,{station_code:AppointmentSelection.getStationCode()})
            .then(response1 => {
              AppointmentSelection.setStationShortDetail(response1.data)
              if(response1.data.user_register_mode=="guest"){
                this.$store.commit('finishLoading',que)
                this.$router.replace({name:'AppointmentNewStep',params:{step_id:'1'},query: {custompage:this.$route.params.custompage}})
              }else{
                axios
                .post(config.api.url.line.station.get_stationmemberstatus
                  ,{ station_code:AppointmentSelection.getStationCode()}
                  ,{ headers: Member.getTokenHeader()})
                .then(response2 => {
                  this.$store.commit('finishLoading',que)
                  if(response2.data.is_stationmember){
                    this.$router.replace({name:'AppointmentNewStep',params:{step_id:'1'},query: {custompage:this.$route.params.custompage}})
                  }else{
                    if(response1.data.staff_register_mode=="auto_accept"){
                      this.$router.replace({name:'RegisterForm',params:{station_code:AppointmentSelection.getStationCode(),callback:{name:'AppointmentNewStep',params:{step_id:'1'},query: {custompage:this.$route.params.custompage}}}})
                    }else{
                      this.$router.replace({name:'RegisterForm',params:{station_code:AppointmentSelection.getStationCode()}})
                    }
                  }
                })
              }
            })
            
        }
    })
  },
  methods : {
  },
}
</script>